import { useQuery } from '@apollo/client'
import { Heading, Spinner } from '@enterprise-ui/canvas-ui-react'
import { BULK_UPDATE } from '../../constants/bulkUtilitiesConstants'
import { getContentHelpersFromGql } from '../../graphql/bulkItemGuide'

/**
 * Render instructions to show bulk upload instructions
 * Instruction content is fetched by graphQL query
 */
const Instructions = () => {
  const { data, loading } = useQuery(getContentHelpersFromGql(), {
    variables: { contentId: 'bulk_upload' },
  })
  const content = data?.getContentHelpers?.results[0]
  const message = content
    ? content?.message
    : `<p class="hc-clr-error">Error in loading content.</p>`

  return (
    <div id="div-bulk-upload-instructions">
      <Heading size={4} className="hc-fs-md font-weight-700">
        {BULK_UPDATE.INSTRUCTIONS.HEADER_TITLE}
      </Heading>
      {loading ? (
        <Spinner
          id="spinner-loading-bulk-instructions"
          data-testid="spinner-loading-bulk-instructions"
          size="dense"
          className="hc-mt-normal"
        />
      ) : (
        <p
          className="hc-fs-md hc-mt-normal font-color-default font-weight-400"
          dangerouslySetInnerHTML={{
            __html: message,
          }}
        />
      )}
    </div>
  )
}

export default Instructions
